// extracted by mini-css-extract-plugin
module.exports = {"container":"ProfilePage_container__E9lj0","title":"ProfilePage_title__2HAbq","card":"ProfilePage_card__2Rxv5"};